export default {
      id: "money-back-usage",
      viewBox: "0 0 27 32",
      url: __webpack_public_path__ + "sprite.svg#money-back",
      toString: function () {
        return this.url;
      }
    }